module.exports = __webpack_public_path__ + "static/media/Piedra.b3ab5002.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Piedra.png
// module id = 180
// module chunks = 0